import { lazy } from 'react';
import { authRoles } from 'app/auth';

const LedgerAppConfig = {
	settings: {
		layout: {}
	},
	auth: [...authRoles.diller, ...authRoles.productModerator],
	routes: [
		{
			path: '/apps/report/ledger',
			component: lazy(() => import('./Datas')),
			exact: true
		},
		{
			path: '/apps/report/ledger/:id',
			exact: true,
			component: lazy(() => import('./single/Datas'))
		},
		{
			path: '/apps/report/ledger/:id/:operation',
			exact: true,
			component: lazy(() => import('./single/Datas'))
		}
	]
};

export default LedgerAppConfig;
